import React from "react";
import {
  Card,
  Stack,
  CardHeader,
  Typography,
  CardContent,
} from "@mui/material";

export default function CustomList({ data = {}, variant = "elevation" }) {
  const { title, value, unit, children } = data;

  return (
    <Card
      variant={variant}
      sx={{ bgcolor: "transparent", minWidth: 200, flexGrow: 1 }}
    >
      <CardHeader
        title={
          <Typography
            pl={1}
            variant="caption"
            borderLeft="3px solid"
            color="text.secondary"
            borderColor="primary.main"
          >
            {title}
          </Typography>
        }
        action={
          <Stack direction="row" alignItems="center">
            {typeof value === "string" ? (
              <Typography variant="subtitle2" fontSize={16}>
                {value}
              </Typography>
            ) : (
              value
            )}
            {unit && (typeof unit === "string" ? (
              <Typography
                width={40}
                fontSize={10}
                align="center"
                component="span"
                variant="caption"
                color="text.secondary"
              >
                {unit}
              </Typography>
            ) : (
              <Stack width={40} alignItems="center">{unit}</Stack>
            ))}
          </Stack>
        }
      />
      {children && (
        <Stack pt={2} p={1} rowGap={1}>
          {children.map((child, i) => (
            <Child key={i} {...child} />
          ))}
        </Stack>
      )}
    </Card>
  );
}

function Child({ title, value, unit, isActive = true, children = [] }) {
  if (isActive) {
    return (
      <Card sx={{ borderRadius: 1, bgcolor: "action.hover" }}>
        <CardHeader
          sx={{ p: 1 }}
          title={
            <Typography variant="caption" color="text.secondary">
              {title}
            </Typography>
          }
          action={
            <Stack direction="row" alignItems="center">
              <Typography variant="subtitle2" fontSize={12}>
                {value}
              </Typography>
              {unit && (
                <Typography
                  width={40}
                  fontSize={10}
                  align="center"
                  component="span"
                  variant="caption"
                  color="text.secondary"
                >
                  {unit}
                </Typography>
              )}
            </Stack>
          }
        />
        {children.length > 0 && (
          <CardContent>
            {children.map((x, i) => (
              <Child key={i} {...x} />
            ))}
          </CardContent>
        )}
      </Card>
    );
  }
  return;
}
